const actionTypes = {
  SET_CATEGORIES: 'SET_CATEGORIES',
  CHANGE_FILTER: 'CHANGE_FILTER',
  SELECT_ITEM: 'SELECT_ITEM',
  bookCategories: ['Beef', 'Chicken', 'Dessert', 'Lamb', 'Seafood', 'Breakfast', 'Vegetarian', 'Starter'],
};

export default actionTypes;
